import React from "react";
import { Grid, Card, CardContent, Typography, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  Send,
  CheckCheck,
  Eye,
  AlertTriangle,
  Clock,
  TrendingUp
} from "lucide-react";

const useStyles = makeStyles((theme) => ({
  gridItem: {
    display: "flex"
  },
  card: {
    flex: 1,
    width: "100%",
    borderRadius: "12px",
    boxShadow: theme.mode === "light"
      ? "0 2px 10px rgba(0,0,0,0.06)"
      : "0 2px 10px rgba(0,0,0,0.3)",
    transition: "transform 0.2s, box-shadow 0.2s",
    border: `1px solid ${theme.palette.divider}`,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minHeight: "100px",
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: theme.mode === "light"
        ? "0 4px 14px rgba(0,0,0,0.12)"
        : "0 4px 14px rgba(0,0,0,0.5)"
    }
  },
  cardContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px !important",
    width: "100%",
    boxSizing: "border-box"
  },
  infoContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    flex: 1,
    minWidth: 0
  },
  value: {
    fontWeight: 700,
    fontSize: "1.55rem",
    lineHeight: 1.2,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: "0.82rem",
    fontWeight: 500,
    marginTop: 4,
    minHeight: "36px",
    display: "flex",
    alignItems: "center",
    lineHeight: 1.25
  },
  iconWrapper: {
    width: 44,
    height: 44,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    marginLeft: 12
  }
}));

const KpiCards = ({ totals = {} }) => {
  const classes = useStyles();

  const totalShipping = totals.totalShipping || 0;
  const totalSent = totals.totalSent || 0;
  const totalDelivered = totals.totalDelivered || 0;
  const totalConfirmed = totals.totalConfirmed || 0;
  const totalFailed = totals.totalFailed || 0;
  const totalPending = totals.totalPending || 0;
  const deliveryRate = totals.deliveryRate || 0;

  const cards = [
    {
      label: "Total Programado",
      value: totalShipping.toLocaleString("pt-BR"),
      icon: Send,
      color: "#2563EB",
      bgColor: "rgba(37, 99, 235, 0.12)"
    },
    {
      label: "Entregues",
      value: totalDelivered.toLocaleString("pt-BR"),
      icon: CheckCheck,
      color: "#16A34A",
      bgColor: "rgba(22, 163, 74, 0.12)"
    },
    {
      label: "Lidos / Confirmados",
      value: totalConfirmed.toLocaleString("pt-BR"),
      icon: Eye,
      color: "#9333EA",
      bgColor: "rgba(147, 51, 234, 0.12)"
    },
    {
      label: "Falhas no Envio",
      value: totalFailed.toLocaleString("pt-BR"),
      icon: AlertTriangle,
      color: "#DC2626",
      bgColor: "rgba(220, 38, 38, 0.12)"
    },
    {
      label: "Aguardando / Fila",
      value: totalPending.toLocaleString("pt-BR"),
      icon: Clock,
      color: "#D97706",
      bgColor: "rgba(217, 119, 6, 0.12)"
    },
    {
      label: "Taxa de Entrega",
      value: `${deliveryRate}%`,
      icon: TrendingUp,
      color: "#0D9488",
      bgColor: "rgba(13, 148, 136, 0.12)"
    }
  ];

  return (
    <Grid container spacing={2}>
      {cards.map((card, index) => {
        const IconComponent = card.icon;
        return (
          <Grid item xs={12} sm={6} md={2} key={index} className={classes.gridItem}>
            <Card className={classes.card}>
              <CardContent className={classes.cardContent}>
                <Box className={classes.infoContainer}>
                  <Typography className={classes.value}>{card.value}</Typography>
                  <Typography className={classes.label}>{card.label}</Typography>
                </Box>
                <Box
                  className={classes.iconWrapper}
                  style={{
                    backgroundColor: card.bgColor,
                    color: card.color
                  }}
                >
                  <IconComponent size={22} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default KpiCards;
